import Util from '../../../utils/util.js';
const isTestEnv = Util.isTestEnvironment();
const HOST = isTestEnv ? `//test.mp.sohu.com/fe/card` : `//v2.sohu.com/mpfe/card`;
// const HOST = `//v2.sohu.com/mpfe/card`
let getCardInfo = (id, successFn, errorFn)=> {
    $.ajax({
        type: 'GET',
        url: `${HOST}/get?ids=${id}`,
        success: successFn,
        error: errorFn,
    })
}

let getVeriCode = (params, successFn, errorFn) => {
    $.ajax({
        type: 'post',
        url: `${HOST}/getCaptcha`,
        data: params,
        dataType: 'json',
        xhrFields: {
            withCredentials: true
        },
        success: successFn,
        error: errorFn
    })
}

let getSignupStatus = (params, successFn, errorFn) => {
    $.ajax({
        type: 'post',
        url: `${HOST}/apply`,
        dataType: 'json',
        data: params,
        xhrFields: {
            withCredentials: true
        },
        success: successFn,
        error: errorFn
    })
}

export {
    getCardInfo,
    getVeriCode,
    getSignupStatus
}